import { Injectable } from '@angular/core';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';
import { CookieService } from 'src/sb-tools/typescript/authentication/cookie.service';
import { TicketTabType } from '../enums/ticket-tab-type.enum';
import { HelperService } from '@sb-tools/typescript/services/helper.service';

@Injectable({ providedIn: 'root' })
export class RightPanelStateService {
    private externalAppIdStateKey = 'rightPanelExternalAppIdState';
    private panelStateKey = 'rightPanelState';
    private tabStateKey = 'rightPanelTabState';

    constructor(
        private windowRef: WindowRef,
        private cookieService: CookieService,
    ) {}

    getPanelState() {
        let result;
        if (HelperService.isLocalStorageNameSupported()) {
            result = this.windowRef.nativeWindow.localStorage.getItem(this.panelStateKey);
        } else {
            result = this.cookieService.getCookie(this.panelStateKey);
        }

        if (result) {
            return JSON.parse(result);
        } else {
            const mq = this.windowRef.nativeWindow.matchMedia('(min-width: 1450px)');

            if (mq.matches) {
                return true;
            }
        }

        return false;
    }

    getExternalAppIdState() {
        let result;

        if (HelperService.isLocalStorageNameSupported()) {
            result = this.windowRef.nativeWindow.localStorage.getItem(this.externalAppIdStateKey);
        } else {
            result = this.cookieService.getCookie(this.externalAppIdStateKey);
        }

        if (result) {
            return JSON.parse(result);
        } else {
            return null;
        }
    }

    getTabState() {
        let result;
        if (HelperService.isLocalStorageNameSupported()) {
            result = this.windowRef.nativeWindow.localStorage.getItem(this.tabStateKey);
        } else {
            result = this.cookieService.getCookie(this.tabStateKey);
        }

        if (result) {
            return JSON.parse(result);
        } else {
            return TicketTabType.notes;
        }
    }

    savePanelState(val: boolean) {
        if (HelperService.isLocalStorageNameSupported()) {
            this.windowRef.nativeWindow.localStorage.setItem(this.panelStateKey, val.toString());
        } else {
            this.cookieService.setCookie(this.panelStateKey, val);
        }
    }

    saveTabState(val: TicketTabType, externalAppId?: number) {
        if (HelperService.isLocalStorageNameSupported()) {
            this.windowRef.nativeWindow.localStorage.setItem(this.tabStateKey, val.toString());
            if (externalAppId) {
                this.windowRef.nativeWindow.localStorage.setItem(this.externalAppIdStateKey, externalAppId.toString());
            }
        } else {
            this.cookieService.setCookie(this.tabStateKey, val);
            if (externalAppId) {
                this.cookieService.setCookie(this.externalAppIdStateKey, externalAppId);
            }
        }
    }
}
